import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Projects } from '../../../../pages/project/Projects';
import { projectsSearchSchema } from '../../../../routing/schemas';
import { RoutePending } from '../../../../components/molecules/loader/RoutePending';
import { projectsListingFilterFromSearch } from '../../../../hooks/useProjectsFilters';
import {
  getListInfiniteProjectsQueryOptions,
  getListTagsQueryOptions,
} from '../../../../pages/project/components/ProjectsCore.queries';

export const Route = createFileRoute('/_private/_home/project/')({
  validateSearch: projectsSearchSchema,
  // `welcome` is left out: it only opens a modal and must not re-run the loader.
  loaderDeps: ({ search: { search, tags, sort } }) => ({ search, tags, sort }),
  loader: ({ context, deps }) => {
    void context.queryClient.prefetchInfiniteQuery(
      getListInfiniteProjectsQueryOptions(context.apiClient, projectsListingFilterFromSearch(deps))
    );
    void context.queryClient.prefetchQuery(getListTagsQueryOptions(context.apiClient));
  },
  component: ProjectsRoute,
  pendingComponent: () => <RoutePending label="Loading projects..." />,
});

function ProjectsRoute() {
  const { apiClient } = Route.useRouteContext();
  return <Projects portalApiClient={apiClient} />;
}
